import { keepCountOnForm } from './search-form';

function clearSearchForm( form: HTMLFormElement, triggerChange: boolean ) {
    form.querySelectorAll<HTMLInputElement | HTMLSelectElement>( 'input,select' ).forEach( function( el ) {
        if ( [ 'offer', 'source' ].includes( el.name ) ) {
            return;
        }

        if ( el.type === 'checkbox' ) {
            el.checked = false;
        } else if ( el.value && el.value.length > 0 ) {
            el.value = '';
        }

        if ( triggerChange ) {
            el.dispatchEvent( new Event( 'change' ) );
        }
    } );
}

function copySearchFormToModal( form: HTMLFormElement, modalForm: HTMLFormElement ) {
    clearSearchForm( modalForm, false );

    const elementsToSkip = [ 'source' ];

    form.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>( '[name]' ).forEach( function( inputElement ) {
        if ( elementsToSkip.includes( inputElement.name ) ) {
            return;
        }

        // handler unmatched case (single 'property-type' sent)
        if ( inputElement.name === 'property-type' ) {
            const groups = modalForm.querySelector<HTMLInputElement>( '[data-groups]' );

            if ( groups ) {
                groups.value = 'other';
            }

            modalForm.querySelectorAll<HTMLElement>( '[data-group]' ).forEach( function( groupElement ) {
                if ( groupElement.dataset.group !== 'other' ) {
                    groupElement.classList.add( 'ts-checktags--hidden' );
                } else {
                    groupElement.classList.remove( 'ts-checktags--hidden' );

                    groupElement.querySelectorAll<HTMLInputElement>( 'input[type=checkbox]' ).forEach( function( el ) {
                        el.checked = true;
                    } );
                }
            } );
            return;
        }

        if ( inputElement.name === 'types' ) {
            const type = inputElement.value;

            if ( type === '' ) {
                return;
            }

            const cbx = modalForm.querySelector<HTMLInputElement>( 'input[name=types][value=' + type + ']' );

            if ( !cbx ) {
                return;
            }

            cbx.checked = true;

            const group = cbx.closest<HTMLElement>( '[data-group]' );

            if ( group ) {
                group.classList.remove( 'ts-checktags--hidden' );
            }

            const groups = modalForm.querySelector<HTMLInputElement>( '[data-groups]' );

            if ( groups && group ) {
                groups.value = group.dataset.group || '';
            }

            return;
        }

        if ( inputElement.name === 'tags' ) {
            const tagCheckbox = modalForm.querySelector<HTMLInputElement>( '[name=' + inputElement.name + '][value=' + inputElement.value + ']' );
            if ( tagCheckbox ) {
                tagCheckbox.checked = true;
            }
            return;
        }

        const dest = modalForm.querySelector<HTMLInputElement>( '[name=' + inputElement.name + ']' );
        if ( !dest ) {
            return;
        }

        if ( dest.type === 'checkbox' ) {
            dest.checked = true;
        } else {
            if ( inputElement.name === 'locationFreeText' ) {
                const freeTextReset = modalForm.querySelector<HTMLButtonElement>( '.awesomplete .reset-field' );

                if ( freeTextReset ) {
                    if ( inputElement.value.length > 0 ) {
                        freeTextReset.style.visibility = '';
                    } else {
                        freeTextReset.style.visibility = 'hidden';
                    }
                }

                const radiusContainer = modalForm.querySelector( '.searchpopup__location-radius' );
                if ( radiusContainer ) {
                    if ( inputElement.dataset.tsGeo === 'true' ) {
                        radiusContainer.classList.remove( 'd-none' );
                    } else {
                        radiusContainer.classList.add( 'd-none' );
                    }
                }
            }

            if ( dest.value === inputElement.value ) {
                return;
            }

            dest.value = inputElement.value;

            if ( inputElement.name === 'locationId' ) {
                dest.dataset.isIsland =  inputElement.dataset.isIsland;
                dest.dataset.isGeocoded =  inputElement.dataset.isGeocoded;
                dest.dataset.longitude =  inputElement.dataset.longitude;
                dest.dataset.latitude =  inputElement.dataset.latitude;
                dest.dataset.id = inputElement.dataset.id;
                dest.dataset.type = inputElement.dataset.type;
                dest.dataset.location = inputElement.dataset.location || '';
            }

            if ( dest.nodeName === 'SELECT' && !inputElement.value ) {
                dest.classList.remove( 'has-value' );
            }

            if ( dest.nodeName === 'SELECT' && inputElement.value ) {
                dest.classList.add( 'has-value' );
            }
        }

        dest.dispatchEvent( new Event( 'change', { bubbles: true } ) );
    } );
}

function openGenericSearchPopup() {
    const popupsearch = document.querySelector<HTMLElement>( '#search-filter-popup' );

    if ( !popupsearch ) {
        return;
    }

    document.documentElement.style.setProperty( '--vh', `${window.innerHeight * 0.01}px` );

    document.body.classList.add( 'popup-open' );

    popupsearch.classList.add( 'pagepopup__wrapper--open' );

    const form = document.querySelector<HTMLFormElement>( '#search-form-base' );
    const modalForm = document.querySelector<HTMLFormElement>( '#search-form-popup' );

    if ( form && modalForm ) {
        copySearchFormToModal( form, modalForm );
    }

    popupsearch.querySelectorAll( '[data-action="close"]' ).forEach( ( btn ) => {
        btn.addEventListener( 'click', function() {
            document.body.classList.remove( 'popup-open' );

            popupsearch.classList.remove( 'pagepopup__wrapper--open' );

            window.requestAnimationFrame( () => {
                document.documentElement.scrollTop = window.router.currentState.scrollPosition;
            } );
        } );
    } );
}

export function prepareSearch( modalForm: HTMLFormElement ): void {
    const btnReset = modalForm.querySelector( '.btn-reset' );

    if ( btnReset ) {
        btnReset.addEventListener( 'click', function() {
            clearSearchForm( modalForm, true );
        } );
    }

    const btnCancel = modalForm.querySelector<HTMLButtonElement>( '.btn-cancel' );

    if ( btnCancel ) {
        btnCancel.addEventListener( 'click', function() {
            const btnClose = modalForm.querySelector<HTMLButtonElement>( '[data-action="close"]' );

            if ( btnClose ) {
                btnClose.click();
            }
        } );
    }
}

function openSearchFilters(): void {
    const modalForm = document.querySelector<HTMLFormElement>( '#search-form-popup' );

    if ( !modalForm ) {
        return;
    }

    prepareSearch( modalForm );

    openGenericSearchPopup();

    if ( modalForm && modalForm.dataset.keepCount && modalForm.dataset.keepCount === 'true' ) {
        keepCountOnForm( modalForm, true );
    }
}

export default openSearchFilters;
